export default __webpack_public_path__ + "static/media/car-8.8a4c88ae.png";